import { computed }          from 'mobx';
import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

export default class EntityTypeModel extends NewFondationsApiModel {
	static get path(): string {
		return '/entity_types/{?id}';
	}

	@computed
	public get label() {
		return this.get('label');
	}
}
